import instance from '../_http';

export default {
    /**
     * 添加
     * @param {*} website
     * @returns
     */
    add: (website) => {
        return instance.post('/api/cms/website',website);
    },
    /**
     *  删除
     */
    remove: (id) => {
        return instance.delete(`/api/cms/website/${id}`);
    },
    /**
     * 更新
     * @param {*} website
     * @returns
     */
    update: (website) => {
        return instance.put('/api/cms/website',website);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/cms/website',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    },
    /**
     * 详情
     * @param {*} id
     * @returns
     */
    detail: (id) => {
        return instance.get(`/api/cms/website/${id}`);
    },
    /**
     * 修改默认站点
     * @param {*} id
     * @param {*} value
     * @returns
     */
    changeDefaultFlag: (id,value)=>{
        return instance.put(`/api/cms/website/${id}/defaultFlag/${value}`);
    }
}